import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertIcon, ChevronDownIcon } from './icons';
export function FAQSection() {
  const faqs = [{
    q: '¿Son licenciados?',
    a: 'Trabajamos profesionalmente en MD, DC y VA con años de experiencia comprobable en la comunidad.'
  }, {
    q: '¿Cómo sé que van a terminar el trabajo?',
    a: 'Geovanny supervisa personalmente cada proyecto — no se va hasta que quedes satisfecho.'
  }, {
    q: '¿Tienen precios altos?',
    a: 'Damos presupuestos claros antes de empezar. Sin sorpresas. Comparamos favorablemente con el mercado.'
  }, {
    q: '¿Pueden hacer trabajos pequeños?',
    a: 'Sí. Desde una pared hasta una remodelación completa — todo tiene atención.'
  }, {
    q: '¿Atienden los fines de semana?',
    a: '24/7 significa todos los días, incluyendo fines de semana y emergencias.'
  }, {
    q: '¿Hablan español?',
    a: 'Sí. 100%. Comunicación clara en tu idioma.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-brand-bg-light border-t border-gray-800" data-id="element-69">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-71">
          <div className="flex items-center justify-center gap-4 mb-16" data-id="element-72">
            <AlertIcon className="w-10 h-10 text-brand-gold" data-id="element-73" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-74">
              Preguntas Frecuentes
            </h2>
          </div>

          <div className="space-y-4" data-id="element-75">
            {faqs.map((faq, index) => <div key={index} className="bg-brand-bg-dark rounded-xl border border-gray-800 overflow-hidden" data-id="element-76">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-77">
                  <span className="text-xl font-heading font-bold text-white pr-8" data-id="element-78">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-6 h-6 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-79" />
                </button>

                <AnimatePresence data-id="element-80">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-81">
                      <div className="p-6 pt-0 text-lg text-gray-400 border-t border-gray-800/50" data-id="element-82">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}